<template>
  <div>
    <div :class="`drawer-right-wrapper`" :style="{
          width: drawerVisible ? isSmall ? '100%' : `${size}px` : '0',
        }">
      <slot name="drawer-content">
      </slot>
    </div>
    <div
      class="drawer-mask"
      :style="{
        width: drawerVisible ? '100vw' : '0',
        opacity: drawerVisible ? '0' : '0',
      }"
      @click="() => closeDrawer()"
    ></div>
  </div>
</template>

<script>
import UtilMixin from '@/mixins/util';

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
    },
  },
  mixins: [UtilMixin],
  computed: {
    drawerVisible() {
      return this.visible;
    },
    isSmall() {
      return this.isMobile();
    },
  },
  methods: {
    closeDrawer() {
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-right-wrapper {
  position: absolute;
  top: 0;
  background: white;
  right: 0;
  height: 100%;
  width: 0; /* initially */
  overflow-x: hidden;
  height: 100%;
  padding-left: 0; /* initially */
  border-left: 1px solid var(--gray-200);
  background: white;
  z-index: 200;
  transition: all 0.5s;
}
.drawer-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 0; /* initially */
  height: 100vh;
  background: #000;
  opacity: 0.3;
  z-index: 199;
  transition: opacity 0.5s;
}
.close-button {
  cursor: pointer;
  position: absolute;
  top: 28px;
  right: 0px;
  margin-left: 24px;
  z-index: 201;
  padding: 10px;
  border: 1px solid #DFE3E8;
  box-sizing: border-box;
  border-radius: 8px;
}
.close-button:hover {
  background: var(--gray-100);
}
  @media (max-width: $sm) {
    .close-button {
      right: unset;
      left: 0px;
    }
  }
</style>
<style>
.close-button img {
  width: 20px;
  color: #0F172A;
}

</style>
